"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventTypes = void 0;

var common_1 = require("./common");

var EventTypes;

(function (EventTypes) {
  EventTypes["PROVIDER_WEBHOOK"] = "provider_webhook";
  EventTypes["SUMSUB_WEBHOOK"] = "sumsub_webhook";
  EventTypes["COMPLY_ADVANTAGE_RESULT"] = "comply_advantage_result";
  EventTypes["PROVIDER_INITIATION"] = "provider_initiation";
  EventTypes["OTHER"] = "other";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));